var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.uppercaseFirstLetter)?_c('span',[_vm._v(_vm._s(_vm._f("uppercaseFirstLetter")(_vm.title)))]):_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }